import { render, staticRenderFns } from "./FriendLink.vue?vue&type=template&id=7d2c84fd&scoped=true"
import script from "./FriendLink.vue?vue&type=script&lang=js"
export * from "./FriendLink.vue?vue&type=script&lang=js"
import style0 from "./FriendLink.vue?vue&type=style&index=0&id=7d2c84fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2c84fd",
  null
  
)

export default component.exports